import { FormActionsMui } from '@app/components/form/FormActionsMui';
import { zodResolver } from '@hookform/resolvers/zod';
import { socialExport } from '@mi-front/api-clients';
import { Box, Grid } from '@mui/material';
import { FormContainer, SwitchElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { z } from 'zod';
import { SocialLanguageField } from '../../components/inputs/SocialLanguageField';
import { BaseSettingsFormProps } from '../../hooks/useSocialExportFactory';
import { FormSection } from '../../screens/manage/platforms/FormSection';
import { DailymotionCategoryField } from './DailymotionCategoryField';

export const dailymotionSettingsSchema = z.object({
  channel: z
    .union([z.nativeEnum(socialExport.DailymotionSettingsDtoChannelEnum), z.literal('')])
    .nullable()
    .optional()
    .transform((val) => (val === '' ? null : val)),
  forKids: z.boolean().nullable().optional(),
  private: z.boolean().nullable().optional(),
  language: z
    .string()
    .nullable()
    .optional()
    .transform((val) => (val === '' ? null : val)),
});

export function DailymotionSettingsForm({
  stationId,
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<socialExport.DailymotionSettingsDto>) {
  const { $t } = useIntl();
  return (
    <FormContainer
      values={{
        channel: defaultSettings.channel,
        forKids: defaultSettings.forKids,
        private: defaultSettings.private,
        language: defaultSettings.language,
      }}
      onSuccess={async (formData) => {
        await onUpdate({
          channel: formData.channel,
          forKids: formData.forKids,
          private: formData.private,
          language: formData.language,
        });
      }}
      resolver={zodResolver(dailymotionSettingsSchema)}
    >
      <FormSection
        title={$t({
          id: 'socialExport.form.defaultValuesUploads',
          defaultMessage: 'Valores por defecto para uploads',
        })}
      >
        <Grid container>
          <Grid item md={4}>
            <DailymotionCategoryField />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item md={4}>
            <SocialLanguageField />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item md={4}>
            <Box display="flex" flexDirection="column" alignItems="flex-start" gap={2}>
              <SwitchElement
                name="forKids"
                label={$t({
                  id: 'socialExport.form.forKids',
                  defaultMessage: 'Contenido apto para niños',
                })}
                color="primary"
              />
              <SwitchElement
                name="private"
                label={$t({
                  id: 'socialExport.form.uploadAsPrivate',
                  defaultMessage: 'Cargar como video privado',
                })}
                color="primary"
              />
            </Box>
          </Grid>
        </Grid>
      </FormSection>
      <FormActionsMui cancel />
    </FormContainer>
  );
}
